var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportManifest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6z",
    fill: "#E0E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2v6h6",
    fill: "#C7D2FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h8v2H8v-2z",
    fill: "#304FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13h6v1H8v-1z",
    fill: "#304FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15h4v1H8v-1z",
    fill: "#304FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12l2 2-2 2",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H12",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportManifest);
export default __webpack_public_path__ + "static/media/importManifest.a7e98b76afbb696beadd5b142d13bcd5.svg";
export { ForwardRef as ReactComponent };